export default {
  isLoading: false,
  error: false,
  errorMessage: null,
  currentUser: null
};
